// Module exists only to be overriten by rollup build with current version
export default "4.2.0";
